import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "11",
  viewBox: "0 0 7 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.61023 4.38179C6.03012 4.38179 6.26301 3.89553 5.99981 3.56837L3.44516 0.392943C3.24502 0.144165 2.86615 0.144166 2.66601 0.392944L0.111364 3.56837C-0.151837 3.89553 0.0810508 4.38179 0.500942 4.38179H5.61023ZM0.500965 6.61827C0.0810745 6.61827 -0.151812 7.10452 0.111389 7.43168L2.66603 10.6071C2.86618 10.8559 3.24505 10.8559 3.44519 10.6071L5.99984 7.43168C6.26304 7.10452 6.03015 6.61827 5.61026 6.61827H0.500965Z",
    fill: "#222327"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_AdminConfigCommissionField = _resolveComponent("AdminConfigCommissionField")!
  const _component_UIInput = _resolveComponent("UIInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_AdminConfigCommissionField, { title: "Внести изменения" }, {
      default: _withCtx(() => [
        _createVNode(_component_SharedSelect, {
          view: "light",
          options: _ctx.displayedOptions,
          value: _ctx.type,
          "onUpdate:value": _ctx.handleType
        }, null, 8, ["options", "value", "onUpdate:value"])
      ]),
      _: 1
    }),
    (_ctx.isUserIdShow)
      ? (_openBlock(), _createBlock(_component_AdminConfigCommissionField, {
          key: 0,
          title: "Фильтр по ID или EMAIL"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UIInput, {
              view: "light",
              placeholder: "Введите фильтр",
              modelValue: _ctx.userFilter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userFilter) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isUserIdShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.b('field'))
        }, [
          _createElementVNode("h4", {
            class: _normalizeClass(_ctx.b('title'))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t("Пользователи")) + " ", 1),
            _createElementVNode("button", {
              style: {"background":"none","border":"none","cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeSort && _ctx.changeSort(...args)))
            }, _hoisted_2)
          ], 2),
          _createVNode(_component_SharedSelect, {
            view: "light",
            placeholder: "Выберите пользователя",
            options: _ctx.displayedUserIdOptions,
            value: _ctx.userId,
            "onUpdate:value": _ctx.handleUserId
          }, null, 8, ["options", "value", "onUpdate:value"])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}